import { useTranslation } from 'react-i18next';
import BoldBlue from './BoldBlue';
import Popup from './Popup';
import { useState } from 'react';
import Input from './Input';

const FabricantsAdd = (props) => {

    const { i18n } = useTranslation('common');
    const [popupOpen, setPopupOpen] = useState(false); 
    const [name, setName] = useState('');
    const [work, setWork] = useState('');
    const [contact, setContact] = useState('');
    const [email, setEmail] = useState('');

    let decodedFabricants = [];
    try {
        decodedFabricants = JSON.parse(props.fabricants);
    } catch (error) {
        console.log(error);
        decodedFabricants = [];
    }

    function addLink(event) {
        event.preventDefault();
        let newFabricant = {
            name,
            work,
            contact,
            email
        }
        decodedFabricants.push(newFabricant);
        props.setFabricants(JSON.stringify(decodedFabricants));
        setPopupOpen(false);
        setName('');
        setWork('');
        setContact('');
        setEmail('');
    }
        
    //fabricants have a name, a "Travail réalisé", a contact and an email

    return (
        <>
            <BoldBlue style={{cursor:"pointer"}} onClick={() => setPopupOpen(true)}>{i18n.language === "fr" ? "Ajouter un fabricant" : "Add a manufacturer"}{props.required && "*"} +</BoldBlue><br/>
            {popupOpen &&
                <Popup close={() => setPopupOpen(false)}>
                    <span className='thin'>{i18n.language === "fr" ? "Ajouter un fabricant" : "Add a manufacturer"}</span><br/>
                    <Input required style={{width:"100%"}} onChange={(event) => setName(event.target.value)} placeholder={i18n.language === "fr" ? "Nom" : "Name"} /><br/>
                    <Input style={{width:"100%"}} onChange={(event) => setWork(event.target.value)} placeholder={i18n.language === "fr" ? "Travail réalisé sur le projet" : "Work done on the project"} /><br/>
                    <Input style={{width:"100%"}} onChange={(event) => setContact(event.target.value)} placeholder={i18n.language === "fr" ? "Contact" : "Contact"} /><br/>
                    <Input style={{width:"100%"}} onChange={(event) => setEmail(event.target.value)} placeholder={i18n.language === "fr" ? "Email" : "Email"} /><br/>
                    {name && <button onClick={addLink}>{i18n.language === 'fr' ? 'Ajouter' : 'Add'}</button>}
                </Popup>
            }
        </>
    );
};

export default FabricantsAdd;
